module.exports = __webpack_public_path__ + "img/SpeakerDisabled.85307eff.svg";